module.exports = __webpack_public_path__ + "media/images/svg/realestate/building-d15d58f6f4a410299927b89bb42be1af.svg";